import { Skeleton } from '@/components/Skeleton'
import { Section } from '@/ui/organisms/Section'

export const FormAppearanceSkeleton = () => (
  <Section.Root>
    <Section.Header className="gap-2">
      <Skeleton className="!h-8 !w-1/3" isLoading={true}>
        <Section.Title className="header-1">Page</Section.Title>
      </Skeleton>
      <Skeleton className="!h-8 !w-2/3" isLoading={true}>
        <Section.Description>
          Customize your own brand color into your form page.
        </Section.Description>
      </Skeleton>
    </Section.Header>
    <Section.Divider className="my-1" />
    <Section.Content className="gap-6 pb-3">
      <div className="flex w-full flex-col items-start gap-2">
        <Skeleton className="!h-8 !w-1/2" isLoading={true}>
          <i></i>
        </Skeleton>
        <div className="flex w-full gap-2">
          <Skeleton className="!h-10 !w-10 rounded-md" isLoading={true}>
            <i></i>
          </Skeleton>
          <Skeleton className="!h-10 !w-full rounded-md" isLoading={true}>
            <i></i>
          </Skeleton>
        </div>
      </div>
      <div className="flex w-full flex-col items-start gap-2">
        <Skeleton className="!h-8 !w-1/2" isLoading={true}>
          <i></i>
        </Skeleton>
        <div className="flex w-full gap-2">
          <Skeleton className="!h-10 !w-10 rounded-md" isLoading={true}>
            <i></i>
          </Skeleton>
          <Skeleton className="!h-10 !w-full rounded-md" isLoading={true}>
            <i></i>
          </Skeleton>
        </div>
      </div>
    </Section.Content>
  </Section.Root>
)
